import { c as _c } from "react/compiler-runtime";
import { FormLabel } from "@/components/atoms/Form/FormLabel";
import { FormIncrementor } from "@/components/atoms/Form/Incrementor/FormIncrementor";
import { FormControl, FormDescription, FormField, FormItem, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { FormDatePicker } from "@/components/Inputs/FormInputs/FormDatePicker";
import { FormToggleGroup } from "@/components/Inputs/FormInputs/form-toggle-group/FormToggleGroup";
import { ROOM_FEATURE_OPTIONS } from "@/constants/features";
import { useRoomDetails } from "./useRoomDetails";
import { useTranslations } from "next-intl";
export function RoomDetails() {
  const $ = _c(51);
  const {
    control,
    t,
    isDemand
  } = useRoomDetails();
  const tFeatures = useTranslations("modules.listings.addRoomListing.features");
  let t0;
  if ($[0] !== t) {
    t0 = t1 => {
      const {
        field
      } = t1;
      return <FormItem><FormLabel required={true}>{t("listingTitle")}</FormLabel><FormControl><Input id="title" placeholder={t("listingTitlePlaceholder")} type="text" autoComplete="title" {...field} /></FormControl><FormMessage /></FormItem>;
    };
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== control || $[3] !== t0) {
    t1 = <FormField control={control} name="title" render={t0} data-sentry-element="FormField" data-sentry-source-file="RoomDetails.tsx" />;
    $[2] = control;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== isDemand || $[6] !== t) {
    t2 = t3 => {
      const {
        field: field_0
      } = t3;
      return <FormItem><FormLabel>{isDemand ? t("demandDescription") : t("roomDescription")}</FormLabel><FormControl><Textarea id="description" placeholder={isDemand ? t("demandDescriptionPlaceholder") : t("roomDescriptionPlaceholder")} className="h-44" autoComplete="description" {...field_0} /></FormControl><FormMessage /></FormItem>;
    };
    $[5] = isDemand;
    $[6] = t;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== control || $[9] !== t2) {
    t3 = <FormField control={control} name="description" render={t2} data-sentry-element="FormField" data-sentry-source-file="RoomDetails.tsx" />;
    $[8] = control;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== isDemand || $[12] !== t) {
    t4 = t5 => {
      const {
        field: field_1
      } = t5;
      return <FormItem><FormLabel required={true}>{isDemand ? t("demandPrice") : t("price")}</FormLabel><FormControl><Input {...field_1} placeholder={isDemand ? t("demandPricePlaceholder") : t("pricePlaceholder")} type="text" onChange={e => {
            const value = e.target.value.replace(/[^\d.]/g, "");
            field_1.onChange(value);
          }} /></FormControl><FormMessage /></FormItem>;
    };
    $[11] = isDemand;
    $[12] = t;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== control || $[15] !== t4) {
    t5 = <FormField control={control} name="rentPrice" render={t4} data-sentry-element="FormField" data-sentry-source-file="RoomDetails.tsx" />;
    $[14] = control;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== control || $[18] !== isDemand || $[19] !== t) {
    t6 = !isDemand && <FormField control={control} name="deposit" render={t7 => {
      const {
        field: field_2
      } = t7;
      return <FormItem><FormLabel>{t("deposit")}</FormLabel><FormControl><Input {...field_2} placeholder={t("depositPlaceholder")} type="text" onChange={e_0 => {
            const value_0 = e_0.target.value.replace(/[^\d.]/g, "");
            field_2.onChange(value_0);
          }} /></FormControl><FormMessage /></FormItem>;
    }} />;
    $[17] = control;
    $[18] = isDemand;
    $[19] = t;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== isDemand || $[22] !== t) {
    t7 = () => <FormItem className="flex flex-col col-span-1"><FormLabel>{isDemand ? t("demandAvailableFrom") : t("availableFrom")}</FormLabel><FormControl><FormDatePicker name="availableFrom" placeholder={t("availableFromPlaceholder")} title={isDemand ? t("demandAvailableFrom") : t("availableFrom")} /></FormControl><FormMessage /></FormItem>;
    $[21] = isDemand;
    $[22] = t;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== control || $[25] !== t7) {
    t8 = <FormField control={control} name="availableFrom" render={t7} data-sentry-element="FormField" data-sentry-source-file="RoomDetails.tsx" />;
    $[24] = control;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== isDemand || $[28] !== t) {
    t9 = t10 => {
      const {
        field: field_3
      } = t10;
      return <FormItem><FormLabel>{isDemand ? t("demandMaxPersons") : t("maxPersons")}</FormLabel><FormControl><FormIncrementor containerClassName="max-w-none" labelOnZero={t("undefined")} value={field_3.value} onChange={field_3.onChange} /></FormControl><FormDescription>{isDemand ? t("demandMaxPersonsHint") : t("maxPersonsHint")}</FormDescription><FormMessage /></FormItem>;
    };
    $[27] = isDemand;
    $[28] = t;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== control || $[31] !== t9) {
    t10 = <FormField control={control} name="maxPersons" render={t9} data-sentry-element="FormField" data-sentry-source-file="RoomDetails.tsx" />;
    $[30] = control;
    $[31] = t9;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  let t11;
  if ($[33] !== t10 || $[34] !== t5 || $[35] !== t6 || $[36] !== t8) {
    t11 = <div className="grid sm:grid-cols-2 gap-8">{t5}{t6}{t8}{t10}</div>;
    $[33] = t10;
    $[34] = t5;
    $[35] = t6;
    $[36] = t8;
    $[37] = t11;
  } else {
    t11 = $[37];
  }
  let t12;
  if ($[38] !== isDemand || $[39] !== t) {
    t12 = isDemand ? t("roomFeaturesDemandTitle") : t("roomFeaturesTitle");
    $[38] = isDemand;
    $[39] = t;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  let t13;
  if ($[41] !== tFeatures) {
    t13 = ROOM_FEATURE_OPTIONS.map(t14 => {
      const {
        key,
        icon
      } = t14;
      return {
        value: key,
        label: tFeatures(key),
        icon
      };
    });
    $[41] = tFeatures;
    $[42] = t13;
  } else {
    t13 = $[42];
  }
  let t14;
  if ($[43] !== t12 || $[44] !== t13) {
    t14 = <FormToggleGroup name="roomFeatures" label={t12} options={t13} data-sentry-element="FormToggleGroup" data-sentry-source-file="RoomDetails.tsx" />;
    $[43] = t12;
    $[44] = t13;
    $[45] = t14;
  } else {
    t14 = $[45];
  }
  let t15;
  if ($[46] !== t1 || $[47] !== t11 || $[48] !== t14 || $[49] !== t3) {
    t15 = <div className="flex flex-col gap-8" data-sentry-component="RoomDetails" data-sentry-source-file="RoomDetails.tsx"><div className="flex flex-col gap-8">{t1}{t3}{t11}{t14}</div></div>;
    $[46] = t1;
    $[47] = t11;
    $[48] = t14;
    $[49] = t3;
    $[50] = t15;
  } else {
    t15 = $[50];
  }
  return t15;
}